<template>
	<div>
		<div class="pg-header">
			<div>
				<label class="title">规则管理</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span class="active">规则管理</span>
				</div>
				<!-- <a class="back noline" @click="goBack">返回</a> -->
			</div>
		</div>

		<div class="table-wrap" v-if="form.add_patient.id">
			<div class="setting">
				<div class="opt">
					抓取规则
				</div>
				<div>
					住院抓取是否开启
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.in_hospital.enable"></el-switch>
				</div>
				<div v-if="form.in_hospital.enable == '1'">抓取频率 <el-input-number size="small"
						:disabled="!form.in_hospital.enable" v-model="form.in_hospital.value"></el-input-number> 小时抓取一次
				</div>
				<div>
					出院抓取是否开启
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.out_hospital.enable"></el-switch>
				</div>
				<div v-if="form.out_hospital.enable == '1'">抓取频率 <el-input-number size="small"
						:disabled="!form.out_hospital.enable" v-model="form.out_hospital.value"></el-input-number> 小时抓取一次
				</div>
				<div>
					门诊抓取是否开启
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.outpatient.enable"></el-switch>
				</div>
				<div v-if="form.outpatient.enable == '1'">抓取频率 <el-input-number size="small"
						:disabled="!form.outpatient.enable" v-model="form.outpatient.value"></el-input-number> 小时抓取一次</div>
				<div>
					检查抓取是否开启
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.pacs.enable"></el-switch>
				</div>
				<div v-if="form.pacs.enable == '1'">抓取频率 <el-input-number size="small" :disabled="!form.pacs.enable"
						v-model="form.pacs.value"></el-input-number> 小时抓取一次</div>
				<div>
					检验抓取是否开启
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.lis.enable"></el-switch>
				</div>
				<div v-if="form.lis.enable == '1'">抓取频率 <el-input-number size="small" :disabled="!form.lis.enable"
						v-model="form.lis.value"></el-input-number> 小时抓取一次</div>
				<div>
					血压抓取是否开启
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.blood_pressure.enable"></el-switch>
				</div>
				<div v-if="form.blood_pressure.enable == '1'">抓取频率 <el-input-number size="small"
						:disabled="!form.blood_pressure.enable" v-model="form.blood_pressure.value"></el-input-number>
					小时抓取一次</div>
			</div>
			<div class="setting">
				<div class="opt">
					手动添加规则
				</div>
				<div>手动添加就诊记录
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.add_record.enable"></el-switch>
				</div>
				<div>
					手动添加患者信息
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.add_patient.enable"></el-switch>
				</div>
			</div>
			<div class="setting">
				<div class="opt">
					院中分配规则
				</div>
				<div>自动分配
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.hospital.enable"></el-switch>
				</div>
				<div>
					已结束患者，出院后允许回退
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.hospital.value"></el-switch>
				</div>
			</div>

			<div class="setting">
				<div class="opt">复诊履约规则</div>
				<div>有效复诊时间 <el-input-number size="small" v-model="form.visit.value"></el-input-number> 日内来复诊均有效</div>
			</div>

			<div class="setting">
				<div class="opt">
					签约规则
				</div>
				<div>
					自动续签
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.sign.enable"></el-switch>
				</div>
				<div v-if="form.sign.enable == '1'">自动续签 <el-input-number size="small" :disabled="!form.sign.enable"
						v-model="form.sign.value"></el-input-number> 年</div>
			</div>

			<div class="setting">
				<div class="opt">
					排期规则
				</div>
				<div>
					出院排期自动过期
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.scheduling.enable"></el-switch>
				</div>
				<div v-if="form.scheduling.enable == '1'">出院患者 <el-input-number size="small"
						:disabled="!form.scheduling.enable" v-model="form.scheduling.value"></el-input-number> 小时未排期，自动过期
				</div>


				<div>
					门诊排期自动过期
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.opd_scheduling.enable"></el-switch>
				</div>
				<div v-if="form.opd_scheduling.enable == '1'">门诊患者 <el-input-number size="small"
						:disabled="!form.opd_scheduling.enable" v-model="form.opd_scheduling.value"></el-input-number> 小时未排期，自动过期
				</div>
			</div>

			<div class="setting">
				<div class="opt">
					复诊短信提醒
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.sms_visit.enable"></el-switch>
				</div>
				<div class="line" v-if="form.sms_visit.enable == '1'">
					<p>
						短信模板名称
						<el-select size="mini" v-model="form.smsVisitValue.templateCode" placeholder="请选择" filterable clearable>
							<el-option v-for="(item,index) in smsList" :key="index" :label="item.templateName" :value="item.templateCode" style="width:180px"></el-option>
						</el-select>
					</p>
				</div>
				<div  class="line" v-if="form.sms_visit.enable == '1'">
					<p>复诊日之前 <el-input-number size="small" :disabled="!form.sms_visit.enable"
							v-model="form.smsVisitValue.remindDay"></el-input-number> 日提醒</P>
					<p>短信发送时间
						<el-time-picker v-model="form.smsVisitValue.sendTime" :picker-options="{
							selectableRange: '00:00:00 - 23:00:00'
						}" :format="customTimeFormat" placeholder="任意时间点">
						</el-time-picker>
					</p>
				</div>
			</div>
			<div class="setting">
				<div class="opt">
					院中管理
				</div>
				<div>
					是否允许PC端填写
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.in_eval.enable"></el-switch>
				</div>
			</div>
			<div class="setting">
				<div class="opt">
					密码管理规则
				</div>
				<div>
					安全验证是否开启
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.password.enable"></el-switch>
				</div>
				<div class="line" v-if="form.password.enable == '1'">
					<p>默认密码 <el-input v-model="form.password.value" /></p>
				</div>
			</div>
			<div class="setting">
				<div class="opt">
					版本号管理
				</div>
				<div class="line">
					<p>当前版本号<el-input v-model="form.front_version.value" /></p>
				</div>
			</div>
			<div class="setting">
				<div class="opt">
					App更新
				</div>
				<div>
					是否强制更新
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.version.enable"></el-switch>
				</div>
				<div class="line" v-if="form.version.enable == '1'">
					<p>当前版本号 <el-input v-model="form.version.name" /></p>
					<p>下载地址 <el-input style="min-width: 300px;" v-model="form.version.value" /></p>
				</div>
				
			</div>
			<div class="setting" v-if="permission">
				<div class="opt">
					软件授权规则
				</div>
				<div>
					是否开启授权
					<el-switch active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
						v-model="form.authorize.enable"></el-switch>
				</div>
				<div style="display: flex;white-space: nowrap;" v-if="form.authorize.enable == '1'">
					<div>提前 <el-input-number size="small" v-model="form.authorizeValue.day"></el-input-number> 日提醒</div>
				</div>
				<div style="display: flex;white-space: nowrap;" v-if="form.authorize.enable == '1'">
					即将过期提醒
					<el-input style="margin-left: 16px;" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
						v-model="form.authorizeValue.rasMsg" />
				</div>
				<div style="display: flex;white-space: nowrap;" v-if="form.authorize.enable == '1'">
					授权口令
					<el-input style="margin-left: 16px;" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
						v-model="form.authorizeValue.rasToken" />
				</div>
			</div>
			<div><el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button></div>
		</div>


	</div>
</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import dayjs from 'dayjs';

export default {
	mixins: [mixin],
	data() {
		return {
			permission: false,
			form: {
				grab: {},
				scheduling: {},
				visit: {},
				sign: {},
				hospital: {},
				version: {},
				sms_visit: {},
				smsVisitValue: {},
				in_eval: {},
				add_patient: {},
				add_record:{},
				authorize: {},
				blood_pressure: {},
				in:{},
				lis:{},
				out_hospital:{},
				outpatient:{},
				pacs:{},
				password:{},
			},
			value1: '',
			smsList:[]
		}
	},
	created() {
		this.loadList()
		this.getSmsList()
	},
	computed: {
		customTimeFormat() {
			return 'HH:mm'; // 使用 'HH:mm' 格式，显示小时和分钟
		},
	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getSysRule(this.filter);
			if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }
			this.form = {
				...res.data,
				smsVisitValue: JSON.parse(res.data.sms_visit.value),
				authorizeValue: JSON.parse(res.data.authorize.value),
			};
			const [hours, minutes] = this.form.smsVisitValue.sendTime.split(':').map(Number);

			// 创建一个新的 JavaScript Date 对象，并设置日期部分为 1970 年 1 月 1 日
			// 这样可以创建一个时间对象，日期部分不影响时间的比较或显示
			this.$nextTick(() => {
				this.form.smsVisitValue.sendTime = new Date(2023, 1, 1, hours, minutes);
			})

			// this.form.sign.enable = this.form.sign.enable;
			// this.form.scheduling.enable = this.form.scheduling.enable;
			// 权限控制
			this.user = JSON.parse(localStorage.getItem('user')).data;
			this.permission = (this.user.user.roleId == "1") ? true : false;

			this.isLoading = false;
		},
		async getSmsList(){
			let res=await api.queryTemplateList({
				pageNumber: 1,
				pageSize: 10,
				templateType: 2
			})
			if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }
			this.smsList=res.data;
		},
		async saveForm() {
			let obj = {
				...this.form,
			}
			const hours = this.form.smsVisitValue.sendTime.getHours().toString().padStart(2, '0'); // 获取小时并确保是两位数
			const minutes = this.form.smsVisitValue.sendTime.getMinutes().toString().padStart(2, '0'); // 获取分钟并确保是两位数
			let time = `${hours}:${minutes}`;
			let smsVal = {
				...this.form.smsVisitValue,
			}
			smsVal.sendTime = time
			obj.sms_visit.value = JSON.stringify(smsVal)

			obj.authorize.value = JSON.stringify(this.form.authorizeValue)

			const res = await api.saveSysRule(this.form);
			if (res.code != 1000) {
				this.$message.error(res.message);
				return;
			}
			this.loadList();
			this.$message({ message: '保存成功', type: 'success' });
		},
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';


.table-wrap {
	padding: 34px;
}

.setting {
	margin-bottom: 30px;
	border-bottom: 1px solid #f6f6f6;

	>div {
		margin-bottom: 24px;
	}

	.opt {
		font-size: 22px;
		font-weight: 500;

		.el-switch {
			margin-left: 20px;
		}
	}

	.line {
		display: flex;
		align-items: center;
		white-space: nowrap;

		p {
			display: flex;
			white-space: nowrap;
			align-items: center;
			margin-right: 16px;

			span {
				width: auto;
				border-radius: 4px;
				border: 1px solid #DCDFE6;
				height: 40px;
				line-height: 40px;
				padding: 0 15px;
				box-sizing: border-box;
				margin-left: 12px;
			}

		}

		.el-input,.el-select {
			margin-left: 12px;
		}
	}

	.el-input-number {
		margin: 0 10px;
	}
}</style>
